import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 64px;\n  border: 1px solid ", ";\n  padding: 16px;\n  border-radius: ", ";\n  font-size: 14px;\n  color: ", ";\n  width: 100%;\n  transition: border-color 250ms ease-in-out;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus,\n  &:hover {\n    outline: 0;\n    border-color: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 300;\n  margin-top: 5px;\n  margin-bottom: 0;\n\n  position: absolute;\n  bottom: 0;\n  left: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: ", ";\n  margin-bottom: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  user-select: none;\n  position: relative;\n\n  /* Note: This gives us room to render an error label below the text field */\n  padding-bottom: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { CharsCounter } from '../TextInput';
import styled from '../../utils/styling/styled-components';
import { TEXT_AREA, TEXT_AREA_LABEL } from '../../utils/testing/TestIDs';
var Container = styled.div(_templateObject());
var Label = styled.label(_templateObject2(), function (props) {
  return props.theme.colors.slate;
});
var ErrorLabel = styled(Label)(_templateObject3(), function (props) {
  return props.theme.colors.red;
});
var Textarea = styled.textarea(_templateObject4(), function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props['data-error'] && "\n      border-color: ".concat(props.theme.colors.red, ";\n      color: ").concat(props.theme.colors.red, ";\n\n      &:focus, &:hover {\n        border-color: ").concat(props.theme.colors.red, ";\n      }\n    ");
}, function (props) {
  return props.disabled && "\n      opacity: 0.5;\n      cursor: not-allowed;\n\n      &:focus, &:hover {\n        border-color: ".concat(props.theme.colors.stoneLight, ";\n      }\n    ");
}, function (props) {
  return props.maxlength ? "\n  &.char-counter {\n    padding: 0 44px 0 16px;\n  }\n  " : '';
});

var TextareaInput = function TextareaInput(_ref) {
  var charCounter = _ref.charCounter,
      error = _ref.error,
      errorText = _ref.errorText,
      id = _ref.id,
      label = _ref.label,
      maxlength = _ref.maxlength,
      value = _ref.value,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["charCounter", "error", "errorText", "id", "label", "maxlength", "value", "className"]);

  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    "data-testid": TEXT_AREA_LABEL,
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement(Textarea, _extends({
    className: maxlength && charCounter ? 'char-counter' : '',
    "data-error": error,
    "data-testid": TEXT_AREA,
    id: id,
    maxLength: maxlength,
    value: value
  }, props)), maxlength && charCounter && /*#__PURE__*/React.createElement(CharsCounter, null, maxlength - (value || '').length), error && errorText && /*#__PURE__*/React.createElement(ErrorLabel, null, errorText));
};

export { TextareaInput };